import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, withKeys as _withKeys, normalizeClass as _normalizeClass, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "row full-width no-wrap" }
const _hoisted_2 = { class: "sfx-search-container-bar full-width" }
const _hoisted_3 = { class: "column reverse" }

import { QMenu } from "quasar"
import SfxBtnIcon from "src/components/button/SfxBtnIcon.vue"
import SfxBtnLink from "src/components/button/SfxBtnLink.vue"
import SfxInput from "src/components/input/SfxInput.vue"
import { useSearchStore } from "src/stores/searchStore"
import { Log } from "src/util/classes/log"
import { Icons } from "src/util/enums/fontAwesomeIcons"
import {
  filterTecModeIssuesDialog,
  filterTecModePerformedWorkDialog,
  filterTecModeWorkOrdersDialog,
} from "src/util/functions/dialogs"
import { showNotImplementedNotification } from "src/util/functions/notifications"
import { computed, ref, watch } from "vue"
import { useI18n } from "vue-i18n"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxSearchBar',
  props: {
  showFilterIcon: {
    type: Boolean,
    default: false,
  },

  showFilterIconBadge: {
    type: Boolean,
    default: false,
  },

  disable: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props

//endregion

//region Variables

const searchStore = useSearchStore()
const searchInput = ref("")
const menuRef = ref<typeof QMenu>()
const { t } = useI18n()

const entityName = computed(() => searchStore.getPlaceholderEntity())
const inputPlaceholder = t("sfxSearch.input_placeholder", { entityName: entityName.value })

const searchHistory = computed(() => {
  let list = [...searchStore.getRecentSearch()]

  if (searchInput.value && searchInput.value.length >= 3) {
    list = list.filter((i) => i.includes(searchInput.value) && i !== searchInput.value)
  }

  return list
})

const recentMenuActive = ref(false)

const searchBarClasses = computed(() => {
  return {
    "sfx-search-bar__menu-open": recentMenuActive.value && searchHistory.value.length > 0,
  }
})

//endregion

//region Functions

function searchItemSelected(searchItem: string) {
  searchInput.value = searchItem
  search()
}

function deleteSearchItem(searchItemIndex: number) {
  try {
    searchStore.removeItemFromRecentSearches(searchItemIndex)
  } catch (error) {
    Log.error({ message: "Failed to remove item from recent search results.", error })
  }
}

function deleteAllSearchItems() {
  searchStore.resetSpecificRecentSearch()
  closeMenu()
}

function search() {
  try {
    searchStore.addItemToRecentSearches(searchInput.value)
    searchStore.term = searchInput.value
  } catch (error) {
    Log.error({ message: "Failed to add item to recent search results.", error })
  }
}

function showFiltersDialog() {
  switch (searchStore.domain) {
    case "issues": {
      return filterTecModeIssuesDialog()
    }
    case "workOrders": {
      return filterTecModeWorkOrdersDialog()
    }
    case "performedWork": {
      return filterTecModePerformedWorkDialog()
    }
    default: {
      showNotImplementedNotification()
    }
  }
}

function openMenu() {
  menuRef.value?.show()
  recentMenuActive.value = true
}

function closeMenu() {
  menuRef.value?.hide()
  recentMenuActive.value = false
}

//endregion

//region Setup Code

watch(
  () => searchInput.value,
  (newSearchVal, oldSearchVal) => {
    if (newSearchVal === null) return

    if (newSearchVal.length >= 3 || (oldSearchVal && newSearchVal.length === 0)) {
      search()
    }
  }
)

watch(
  () => props.disable,
  (newDisable) => {
    if (newDisable) {
      closeMenu()
    }
  }
)

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_badge = _resolveComponent("q-badge")!
  const _directive_close_popup = _resolveDirective("close-popup")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(SfxInput, {
        modelValue: searchInput.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchInput).value = $event)),
        class: _normalizeClass(["full-width sfx-search-bar", searchBarClasses.value]),
        debounce: "500",
        clearable: "",
        placeholder: _unref(inputPlaceholder),
        onKeydown: _withKeys(search, ["enter"]),
        onClear: search,
        onFocus: openMenu,
        disable: props.disable
      }, _createSlots({
        default: _withCtx(() => [
          (searchHistory.value.length > 0)
            ? (_openBlock(), _createBlock(_unref(QMenu), {
                key: 0,
                ref_key: "menuRef",
                ref: menuRef,
                modelValue: recentMenuActive.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((recentMenuActive).value = $event)),
                "no-parent-event": "",
                "no-focus": "",
                fit: "",
                class: "sfx-search-bar__menu",
                "transition-show": "jump-down",
                "transition-hide": "jump-up"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_list, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_3, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchHistory.value, (searchItem, searchItemIndex) => {
                          return _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                            key: searchItem,
                            clickable: "",
                            dense: "",
                            class: "full-width q-my-xs"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_section, {
                                onClick: ($event: any) => (searchItemSelected(searchItem))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_item_label, { class: "ellipsis" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(searchItem), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1032, ["onClick"]),
                              _createVNode(_component_q_item_section, { side: "" }, {
                                default: _withCtx(() => [
                                  _createVNode(SfxBtnIcon, {
                                    class: "sfx-search-bar__menu_delete-icon",
                                    icon: _unref(Icons).DELETE,
                                    padding: "none",
                                    onClick: ($event: any) => (deleteSearchItem(searchItemIndex))
                                  }, null, 8, ["icon", "onClick"])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)), [
                            [_directive_close_popup],
                            [_directive_ripple]
                          ])
                        }), 128))
                      ]),
                      _createVNode(_component_q_separator, {
                        inset: "",
                        spaced: ""
                      }),
                      _createVNode(SfxBtnLink, {
                        class: "full-width q-pt-none",
                        dense: "",
                        onClick: deleteAllSearchItems
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("b", null, _toDisplayString(_ctx.$t("sfxSearch.clear_search_history")), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"]))
            : _createCommentVNode("", true)
        ]),
        _: 2
      }, [
        (!searchInput.value)
          ? {
              name: "append",
              fn: _withCtx(() => [
                _createVNode(SfxBtnIcon, {
                  class: "sfx-search-bar__search-button",
                  icon: _unref(Icons).SEARCH,
                  padding: "none",
                  onClick: search
                }, null, 8, ["icon"])
              ]),
              key: "0"
            }
          : undefined
      ]), 1032, ["modelValue", "class", "placeholder", "disable"])
    ]),
    (props.showFilterIcon)
      ? (_openBlock(), _createBlock(SfxBtnIcon, {
          key: 0,
          icon: _unref(Icons).FILTER,
          padding: "0 8px",
          disable: props.disable,
          onClick: showFiltersDialog
        }, {
          default: _withCtx(() => [
            (props.showFilterIconBadge)
              ? (_openBlock(), _createBlock(_component_q_badge, {
                  key: 0,
                  color: "secondary",
                  class: "q-ma-sm",
                  floating: "",
                  rounded: ""
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["icon", "disable"]))
      : _createCommentVNode("", true)
  ]))
}
}

})